'use client'
import { Opportunity } from '@/types/newt/opportunity'
import { ContactTemplate } from '../forms/ContactForm'
import { Department } from '@/types/newt/department'

type ContactPageProps = {
  departments: Department[]
  currentUrl: string
  opportunities: Opportunity[]
}

const ContactPage: React.FC<ContactPageProps> = ({
  departments,
  opportunities,
  currentUrl,
}) => {
  return (
    <>
      <ContactTemplate
        content={{}}
        departments={departments}
        opportunities={opportunities}
      />
    </>
  )
}

export default ContactPage
